export interface Review {
  name: string;
  rating: number;
  text: { es: string; en: string };
  date: string;
}

export const reviews: Review[] = [
  {
    name: 'Analy E.',
    rating: 5,
    text: {
      es: 'Un lugar increíble para disfrutar crepas y café ☕✨. Desde que entras, el ambiente es muy acogedor y perfecto tanto para platicar como para trabajar un rato. Las crepas están deliciosas, con ingredientes frescos y muy bien preparadas; hay opciones tanto dulces como saladas, y todas valen la pena. El café y matcha también es de muy buena calidad, bien servido y con gran sabor. Todo excelente. Muy recomendado.',
      en: "An amazing place to enjoy crepes and coffee ☕✨. From the moment you walk in, the atmosphere is very welcoming and perfect for both chatting and getting some work done. The crepes are delicious, with fresh ingredients and beautifully prepared; there are sweet and savory options, and they're all worth it. The coffee and matcha are also excellent quality, well served and full of flavor. Everything was excellent. Highly recommended.",
    },
    date: '17/04/2026',
  },
  {
    name: 'Valeria H.',
    rating: 5,
    text: {
      es: 'El espacio es pequeño y acogedor, el personal es suuuper amable y la comida es muy buena, profe el chai, marcha y waffle, recomiendo cualquiera de eso 100/10 definitivamente volvería',
      en: 'The space is small and cozy, the staff is suuuper friendly and the food is very good — try the chai, matcha and waffle, I recommend any of those, 100/10, I would definitely come back.',
    },
    date: '18/04/2026',
  },
  {
    name: 'Frida C.',
    rating: 5,
    text: {
      es: 'Todo lo que preparan es delicioso, he probado crepa, wafles, frappes, lates y todo me ha encantado 🫰🏻 el lugar es súper bonito y acogedor 🩷',
      en: "Everything they make is delicious — I've tried crepes, waffles, frappes, lattes and I've loved it all 🫰🏻 the place is super pretty and cozy 🩷",
    },
    date: '14/01/2026',
  },
  {
    name: 'Cesia R.',
    rating: 5,
    text: {
      es: 'Un lugar muy bonito con excelente servicio, un lugar donde puedes disfrutar de una experiencia diferente a cualquier otro lugar 🫰🏼',
      en: 'A very pretty place with excellent service, somewhere you can enjoy an experience unlike anywhere else 🫰🏼',
    },
    date: '20/12/2025',
  },
];

export const googleReviewsUrl = 'https://maps.app.goo.gl/jqDpMApMGB4RS6k96';

export const REVIEWS_ORIGINAL_LANGUAGE = 'es';
